import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IMultipleContentTypeResult } from '../../../httpClient/serverApi/types/IResponse';

export interface ContentItem {
  contentId: string;
  contentType: string;
}

export enum ContainerType {
  project = 'PROJECT',
  personal_space = 'PERSONAL_SPACE'
}

export interface MoveContentToContainerParams {
  containerId: string;
  containerType: ContainerType;
  contentItems: ContentItem[];
}

export class MoveContentToContainerRequest extends Request<MoveContentToContainerParams, IMultipleContentTypeResult> {
  constructor(params: MoveContentToContainerParams) {
    super('moveContentToContainer', params);
  }
}
